import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export default function PickingConfirmation({ onClose }) {
  return (
    <Dialog open fullWidth maxWidth="sm" onClose={onClose} PaperProps={{ sx: { borderRadius: 2 } }}>
      <DialogTitle sx={{ position: "relative", py: 3 }}>
        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
          <Typography variant="h2" color="textPrimary" align="center">
            Picking Confirmation
          </Typography>
        </Box>
        <IconButton
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
          aria-label="Close"
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Box mt={1} display="flex" flexDirection="column" alignItems="center" textAlign="center">
          <Box
            component="img"
            borderRadius={2}
            width="100%"
            maxWidth={450}
            minHeight={286}
            src="/assets/picked-confirmation.webp"
            alt="Confirmation"
          />
          <DialogContentText sx={{ mt: 3 }}>Your order is ready to be delivered.</DialogContentText>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
